/**
 * @generated SignedSource<<483e14e7e9f056b73f4db6f7d603ef69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type VerifyEmailInput = {
  token: string;
};
export type ConfirmEmailAuthenticated_verifyEmail_Mutation$variables = {
  input: VerifyEmailInput;
};
export type ConfirmEmailAuthenticated_verifyEmail_Mutation$data = {
  readonly verifyEmail: {
    readonly token: string;
  } | null;
};
export type ConfirmEmailAuthenticated_verifyEmail_Mutation = {
  response: ConfirmEmailAuthenticated_verifyEmail_Mutation$data;
  variables: ConfirmEmailAuthenticated_verifyEmail_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyEmailPayload",
    "kind": "LinkedField",
    "name": "verifyEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfirmEmailAuthenticated_verifyEmail_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfirmEmailAuthenticated_verifyEmail_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "52be114acc547aeb680b4328ec9625fc",
    "id": null,
    "metadata": {},
    "name": "ConfirmEmailAuthenticated_verifyEmail_Mutation",
    "operationKind": "mutation",
    "text": "mutation ConfirmEmailAuthenticated_verifyEmail_Mutation(\n  $input: VerifyEmailInput!\n) {\n  verifyEmail(input: $input) {\n    token\n  }\n}\n"
  }
};
})();

(node as any).hash = "f19deb640675ea67ad308fac96ced3e5";

export default node;
